/* ===========================================
   Why Stanlee — Feature Carousel
   Manual drag / swipe / wheel / arrow navigation.
   No autoplay, no infinite loop.
   =========================================== */

(function () {
  function initCarousel(wrapper) {
    var track = wrapper.querySelector('[data-ws-track]');
    var prevBtn = wrapper.querySelector('[data-ws-prev]');
    var nextBtn = wrapper.querySelector('[data-ws-next]');

    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.ws-card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 24);
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    /* ---- Mouse drag-to-scroll ---- */
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) moved = true;
      track.scrollLeft = startScroll - delta;
    });

    /* Prevent accidental click-through (e.g. on cards) right after a drag */
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    /* ---- Horizontal mouse wheel support ---- */
    track.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          track.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      },
      { passive: false }
    );

    /* ---- Keyboard support ---- */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        scrollByStep(1);
      } else if (e.key === 'ArrowLeft') {
        scrollByStep(-1);
      }
    });

    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.ws-carousel-wrapper').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when a section is added/re-rendered in the Theme Editor */
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector('.ws-carousel-wrapper');
    if (wrapper) initCarousel(wrapper);
  });
})();
